import React, { useState, useEffect, Fragment } from 'react'

import { Button, Col, DatePicker, Form, Modal, notification, Row, Spin, Typography } from 'antd'
import { ExportOutlined , SnippetsOutlined} from '@ant-design/icons'

import UnLock from 'components/UnLock/UnLock';
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import MessageStatistics from './MessageStatistics';
import MessagingPlatformStatistics from './MessagingPlatformStatistics';
import MessageStatisticsChart from './MessageStatisticsChart';
import MessageStatisticsLineChart from './MessageStatisticsLineChart';
import MessageService from 'services/messageService'; 
import { useSelector } from 'react-redux';


const { RangePicker } = DatePicker;
const { Title } = Typography;

const convertDataForChart = (reportOutput,translation) => {
  const labels = reportOutput.summaryMessageByType?.map(item => {
    return  item?.period
  }) || [];
  const totalMessageSMS = reportOutput.summaryMessageByType?.map(item => item?.totalMessageSMS || 0) || [];
  const totalMessageAPNS = reportOutput.summaryMessageByType?.map(item => item?.totalMessageAPNS || 0) || [];
  const totalMessageZNS = reportOutput.summaryMessageByType?.map(item => item?.totalMessageZNS || 0) || [];
  const totalMessageEmail = reportOutput.summaryMessageByType?.map(item => item?.totalMessageEmail || 0) || [];

  const chart = {
    labels,
    datasets: [
      {
        label: translation('sms.allSMS'),
        data: totalMessageSMS,
        backgroundColor: "#52C41A",
        stack: 'Stack 0',
      },
      {
        label: translation('sms.allAPNS'),
        data: totalMessageAPNS,
        backgroundColor: "#1890FF",
        stack: 'Stack 0',
      },
      {
        label: translation('sms.allZNS'),
        data: totalMessageZNS,
        backgroundColor: "#d48806",
        stack: 'Stack 0',
      },
      {
        label: translation('sms.allEmail'),
        data: totalMessageEmail,
        backgroundColor: "#CF1322",
        stack: 'Stack 0',
      },
    ],
  };

  const messages = {
    total: reportOutput?.totalMessage, // Tổng số tin nhắn của tất cả các nền tảng
    totalSuccess: reportOutput?.totalMessageSuccess, // Tổng số tin nhắn tốt cầu
    totalPrice: (reportOutput?.totalMessagePriceSMS||0) + (reportOutput?.totalMessagePriceAPNS||0) + (reportOutput?.totalMessagePriceZNS||0) + (reportOutput?.totalMessagePriceEmail||0),
    sms: {
      total: reportOutput?.totalMessageSMS, // Tổng số tin nhắn SMS
      totalPrice: reportOutput?.totalMessagePriceSMS, // Tổng số tiền SMS
      totalSuccess: reportOutput?.totalMessageSMSSuccess, // Tổng số tiền SMS thành công
    },
    zns: {
      total: reportOutput?.totalMessageZNS, // Tổng số tin nhắn ZNS
      totalPrice: reportOutput?.totalMessagePriceZNS, // Tổng số tiền ZNS
      totalSuccess: reportOutput?.totalMessageZNSSuccess, // Tổng số tiền ZNS thành cong
    },
    apns: {
      total: reportOutput?.totalMessageAPNS, // Tổng số tin nhắn APNS
      totalPrice: reportOutput?.totalMessagePriceAPNS, // Tổng số tiền APNS
      totalSuccess: reportOutput?.totalMessageAPNSSuccess, // Tổng số tiền APNS thành cong
    },
    email: {
      total: reportOutput?.totalMessageEmail, // Tổng số tin nhắn Email
      totalPrice: reportOutput?.totalMessagePriceEmail, // Tổng số tiền Email
      totalSuccess: reportOutput?.totalMessageEmailSuccess, // Tổng số tiền Email thành cong
    },
  };

  return { chart, messages };
};

const convertDataForChartAndMessages = (reportOutput,translation) => {
  const labels = reportOutput.summaryMessageByStatus?.map(item => {
    return  item?.period;
  }) || [];;
  const datasetSuccess = reportOutput.summaryMessageByStatus?.map(item => item.totalMessageSuccess || 0) || [];;
  const datasetInProgress = reportOutput.summaryMessageByStatus?.map(item => item.totalMessageInprogress || 0) || [];;
  const datasetFailed = reportOutput.summaryMessageByStatus?.map(item => item.totalMessageFailed || 0) || [];;

  const chart = {
    labels,
    datasets: [
      {
        label: translation('sms.sentSuccessfully'),
        data: datasetSuccess,
        backgroundColor: "#52C41A",
      },
      {
        label: translation('sms.sending'),
        data: datasetInProgress,
        backgroundColor: "#d48806",
      },
      {
        label: translation('sms.failedToSend'),
        data: datasetFailed,
        backgroundColor: "#CF1322",
      },
    ],
  }

  const messages = {
    sms: {
      total: reportOutput?.totalMessage, // Tổng số tin nhắn
      sent: {
        value: reportOutput?.totalMessageSuccess, // Tổng số tin nhắn đã gửi thành công
        lastMonthValueDiff: {
          type: "increase", // Giả sử rằng số lượng tin nhắn đã gửi tăng so với tháng trước
        },
      },
      pending: {
        value: reportOutput?.totalMessageInprogress, // Tổng số tin nhắn đang chờ gửi
        lastMonthValueDiff: {
          type: "decrease", // Giả sử rằng số lượng tin nhắn đang chờ giảm so với tháng trước
        },
      },
      failed: {
        value: reportOutput?.totalMessageFailed, // Tổng số tin nhắn gửi thất bại
        lastMonthValueDiff: {
          type: "increase", // Giả sử rằng số lượng tin nhắn thất bại tăng so với tháng trước
        },
      },
    },
  };

  return { chart, messages };
}

function StatisticalSMS() {
  const setting = useSelector((state) => state.setting);
  const { t: translation } = useTranslation()
  const [statisticalData, setStatisticalData] = useState({})
  const [isLoading , setIsLoading] = useState(false); 
  const [filter, setFilter] = useState({
    startDate: moment().set('month', moment().month()-5).startOf('month').format('DD/MM/YYYY'),
    endDate: moment().endOf("month").format("DD/MM/YYYY"),
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenModalRecount, setIsOpenModalRecount] = useState(false)
  const [formRecount] = Form.useForm()
  const [loadingSubmit, setLoadingSubmit] = useState(false)

  const handleToggleOpenModalRecount = () => {
    if (!isOpenModalRecount) {
      setIsOpenModalRecount(true);
    }else{
      setIsOpenModalRecount(false)
      formRecount.resetFields()
    }
  }
  const handleSubmitRecount = (values) => {
    if (loadingSubmit) {
      return
    }
    const payload = {
      reportDate : moment(values.reportDate).format('DD/MM/YYYY'),
    }
    setLoadingSubmit(true)
    MessageService.updateMsgCustomerMarketingReportById(payload).then((result) => {
      if (result?.isSuccess) {
        if (result?.data?.data){
          notification["success"]({
            message: "",
            description: translation("updateSuccess"),
          });
          onFilterByDate()
        }
        else{
          notification["success"]({
            message: "",
            description: translation("There_is_no_data_to_update"),
          });
        }
        handleToggleOpenModalRecount()
      }
      else{
        notification["error"]({
          message: "",
          description: translation("updateFailed"),
        });
      }
    }).finally(() => {
      setLoadingSubmit(false)
    })
    
  }

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };


  const messageStatistics = convertDataForChartAndMessages(statisticalData,translation);
  const messagingPlatformStatistics  = convertDataForChart(statisticalData,translation);

  const onFilterByDate = async () => {
    const { startDate, endDate } = filter
    setIsLoading(true);
    await MessageService.getReportList({
      startDate: startDate,
      endDate: endDate
    }).then((result) => {
      if(result){
        setStatisticalData(result.data);
      }
      setIsLoading(false);
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    onFilterByDate()
  }, [filter])

  if(isLoading){
    return <Spin />
  }

  return (
    <Fragment>
      {setting.enableMarketingMessages === 0 ? <UnLock /> :
        <main>
          <Row gutter={[24, 24]} align="start">
              <Col xs={24} md={12} lg={6} xl={4}>
                <RangePicker
                  // style={{ flexGrow: 1 }}
                  picker='month'
                  defaultValue={[
                    moment(filter.startDate, "DD/MM/YYYY"),
                    moment(filter.endDate, "DD/MM/YYYY")
                  ]}
                  className='w-100'
                  allowClear={false}
                  onChange={(dates, dateStrings) => {
                    if (dates && dates[0] && dates[1]) {
                      let endMonth = moment(dates[1], "DD/MM/YYYY").endOf('month');
                      let startMonth = moment(dates[0], "DD/MM/YYYY").startOf('month');
                      let totalMonthsInRange = endMonth.diff(startMonth, 'months') + 1;
                      if (totalMonthsInRange > 12) {
                        showModal()
                      }else{
                        let start = moment(dates[0]).startOf('month').format("DD/MM/YYYY")
                        let end = moment(dates[1]).endOf('month').format("DD/MM/YYYY")
                        setFilter({
                          ...filter,
                          startDate: start,
                          endDate:  end
                        });
                      }
                    }
                  }}
                  format="DD/MM/YYYY"
                />
              </Col>
              <Col xs={24} md={12} lg="auto" className="d-flex align-items-center gap-4">
                {/* <BasicButtonPrimary
                  className="d-flex align-items-center gap-1"
                  onclick={onFilterByDate}
                  icon={<ExportOutlined />}
                  text={translation("report")}
                /> */}
                <Button
                  onClick={onFilterByDate}
                  className="d-flex align-items-center gap-1"
                  icon={<ExportOutlined />}>
                    {translation("report")}
                </Button>
                <Button
                  onClick={handleToggleOpenModalRecount}
                  className="d-flex align-items-center gap-1"
                  icon={<SnippetsOutlined />}>
                    {translation("Recount")}
                </Button>
                {/* <BasicButtonPrimary
                  className="d-flex align-items-center gap-1"
                  onclick={handleToggleOpenModalRecount}
                  icon={<SnippetsOutlined />}
                  text={translation("Recount")}
                /> */}
              </Col>

          </Row>
      <div className="row">
        <div className="col-md-4 col-lg-4 col-xl-3 mb-3 d-flex align-items-center">


        </div>
        <div className="col-6 col-md-2 col-lg-2 col-xl-1 mb-3">
          
        </div>
        <div className="col-6 col-md-2 col-lg-2 col-xl-1 mb-3">
          
        </div>
      </div>
      <div>
        <Title level={3} className='title-normal mt-2 mb-0'>
          {translation('sms.numberOfMessagesInUse')}
        </Title>
        <div className='row mt-4'>
          <MessageStatistics />
        </div>

        <Title level={3} className='title-normal mt-2 mb-0'>
          {translation('sms.statisticsOfSentMessagesByType')}
        </Title>
        <div className='row'>
          <div className='col-12 col-lg-12'>
            <MessageStatisticsChart chartData={messagingPlatformStatistics.chart} />
          </div>
        </div>

        <Title level={3} className='title-normal mt-4 mb-0'>
          {translation('sms.statisticsOfSentMessages')}
        </Title>
        <div className='row mt-4'>
          <MessagingPlatformStatistics statisticalData={messagingPlatformStatistics} />
        </div>

        <Title level={3} className='title-normal mt-2 mb-0'>
          {translation('sms.messageStatisticsByStatus')}
        </Title>
        <div className='row'>
          <div className='col-12 col-lg-12'>
            <MessageStatisticsLineChart chartData={messageStatistics.chart} />
          </div>
        </div>
      </div>
      <>
    <Modal
      title={translation("sms.getData")}
      visible={isModalOpen}
      footer={[
        <Button key="back" onClick={handleOk}>
            OK
        </Button>
      ]}
      >
        <p>{translation("sms.onlyGetData6Month")}</p>
    </Modal>
    
    <Modal
      title={translation("Recount_by_day")}
      visible={isOpenModalRecount}
      onCancel={handleToggleOpenModalRecount}
      footer={[
        <Button loading={loadingSubmit} key="back" onClick={()=>formRecount.submit()}>
            OK
        </Button>
      ]}
      >
        <Form form={formRecount} onFinish={handleSubmitRecount} layout="vertical">
          <div className="row">
            <div className="col-12">
              <Form.Item
                label={translation("Recount_Date")}
                name="reportDate"
                rules={[
                  {
                    required: true,
                    message: translation("Please_enter_recount_date"),
                  },
                ]}
              >
                <DatePicker
                    className="w-100"
                    format="DD/MM/YYYY"
                    placeholder={translation('Recount_Date')}
                    disabledDate={(current) => {
                      return current && current >= moment().startOf('day');
                    }}
                  />
              </Form.Item>
            </div>
          </div>
        </Form>
    </Modal>
          </>
        </main>
      }
    </Fragment>
  )
}

export default StatisticalSMS 